// document.addEventListener("DOMContentLoaded", () => {

//     const productFormSelector = document.querySelector(".m-product-form--main");
//     if (!productFormSelector) return;

//     const productForm = productFormSelector.querySelector("form");
//     if (!productForm) return;

//     const productId_Form = productForm.querySelector("input[name='id']");
//     if (!productId_Form) return;

//     let lastValue = productId_Form.value;
      
//     const observer = new MutationObserver(() => {
//         const currentValue = productId_Form.value;

//         if (currentValue !== lastValue) {
             
   
//             allDescs = document.querySelectorAll("div[data-var-for");
      

//             allDescs.forEach(function(allDesc){
//                 dataVarFor = allDesc.getAttribute("data-var-for");
                 
//                 if(dataVarFor == currentValue){
                
//                     allDesc.classList.add("active");
//                 }else{
//                     allDesc.classList.remove("active");
//                 }
//             });
//             lastValue = currentValue;
//         }
//     });

//     observer.observe(productId_Form, {
//         attributes: true,
//         attributeFilter: ["value"]
//     });
// });


// ibrahim code


document.addEventListener("DOMContentLoaded", () => {

  const productForm = document.querySelector(".m-product-form--main form");
  if (!productForm) return;

  const variantInput = productForm.querySelector("input[name='id']");
  if (!variantInput) return;

  function updateVariantDescription(variantId) {
    const allDescs = document.querySelectorAll("[data-var-for]");

    allDescs.forEach(desc => {
      desc.classList.toggle(
        "active",
        desc.getAttribute("data-var-for") === variantId
      );
    });
  }

  // 🔹 Run once on page load (default variant)
  updateVariantDescription(variantInput.value);

  // 🔹 Observe variant changes
  const observer = new MutationObserver(() => {
    updateVariantDescription(variantInput.value);
  });

  observer.observe(variantInput, {
    attributes: true,
    attributeFilter: ["value"]
  });

});
